import { CommonModule }                    from '@angular/common';
import { NgModule }                        from '@angular/core';
import { ModalBaseModule }                 from '@core/modal-base/modal-base.module';
import { ShowInvalidTenantModalComponent } from '@core/modals/show-invalid-tenant/show-invalid-tenant-modal.component';


@NgModule( {
	declarations: [
		ShowInvalidTenantModalComponent
	],
	imports: [
		// Angular
		CommonModule,

		// Modal Base
		ModalBaseModule
	]
} )
export class ShowInvalidTenantModalModule {}
